import { Total } from "@repo/apis/bag";
import { BagSdkMethod } from "../utils/method-initialiser";

type SubtotalPrice = {
  text: string;
} | null;

type PublicGetSubtotalPriceMethod = () => SubtotalPrice;
type GetSubtotalPriceMethod = BagSdkMethod<PublicGetSubtotalPriceMethod>;

export const getSubtotalPriceInitialiser: GetSubtotalPriceMethod =
  ({ state }) =>
  () => {
    const bag = state.getBag();

    if (!bag || !bag.total?.itemsSubTotal) {
      return null;
    }

    return {
      text: (bag.total as Total).itemsSubTotal.text,
    };
  };
